"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bnToAddress = void 0;
const Address_1 = require("../address/Address");
function bnToAddress(chain, bn) {
    let r = bn.toString("hex");
    while (r.length < 64) {
        r = "0" + r;
    }
    return new Address_1.Address(chain, Buffer.from(r, "hex"));
}
exports.bnToAddress = bnToAddress;
